<div class="container-md p-md-0">
  <ts-asset-selection
    header="{{ 'my_eligible_devices' | translate }}"
    no_asset_text="{{ 'no_eligible_devices' | translate }}"
    [asset_fields]="['plan', 'add_on_features', 'contract_end_date', 'upgrade_eligible_date']"
    [existing_asset]="existing_asset"
    (asset_selection_emit)="selectAsset($event)"
  />
</div>

<ng-template #confirmUpgradeEligibleModal>
  <ts-confirm-upgrade-eligible
    modal_header="{{ 'upgrade_device' | translate }}"
    [asset]="active_asset"
    (confirm_upgrade_eligible)="continueToUpgradeDevice($event)"
  />
</ng-template>
